import _ from 'lodash';
import stringify from 'json-stringify-safe'
import { handleApiResponse, apiReadWithAuth } from '../../fetchUtils';

export const RESET_SECTION_FORM = 'RESET_SECTION_FORM'
export const CLEAR_PASSWORDS = 'CLEAR_PASSWORDS'
export const BEGIN_SECTION_CREATE = 'BEGIN_SECTION_CREATE'
export const SECTION_CREATE_SUCCESS = 'SECTION_CREATE_SUCCESS'
export const SECTION_CREATE_FAILURE = 'SECTION_CREATE_FAILURE'
export const BEGIN_SECTION_UPDATE = 'BEGIN_SECTION_UPDATE'
export const SECTION_UPDATE_SUCCESS = 'SECTION_UPDATE_SUCCESS'
export const SECTION_UPDATE_FAILURE = 'SECTION_UPDATE_FAILURE'
export const SECTION_SUBMIT_SUCCESS_HANDLED = 'SECTION_SUBMIT_SUCCESS_HANDLED'
export const SET_FIELD_AUTO_GENERATION = 'SET_FIELD_AUTO_GENERATION'

export function resetSectionForm() {
  return { type: RESET_SECTION_FORM }
}

function beginSectionCreate() {
  return { type: BEGIN_SECTION_CREATE }
}

function sectionCreateSuccess(newSectionId) {
  return { type: SECTION_CREATE_SUCCESS, newSectionId }
}

function sectionCreateFailure(errorMessage) {
  return { type: SECTION_CREATE_FAILURE, errorMessage }
}

export function submitCreateSection(formData) {
  return dispatch => {
    dispatch(beginSectionCreate())
    return fetch('/sections', {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => handleApiResponse(response))
    .then(json => {
      if(json.id){
        dispatch(sectionCreateSuccess(json.id))
        dispatch(fetchStudentGroupings())
      }
      else if(json.unauthorized){ dispatch(sectionCreateFailure(json.unauthorized)) }
      else if(json.errors){ dispatch(sectionCreateFailure(json.errors.join("\n"))) }
    })
    .catch(error => dispatch(sectionCreateFailure(error.message)))
  }
}

function beginSectionUpdate() {
  return { type: BEGIN_SECTION_UPDATE }
}

function sectionUpdateSuccess(passwords) {
  return { type: SECTION_UPDATE_SUCCESS, passwords }
}

function sectionUpdateFailure(errorMessage) {
  return { type: SECTION_UPDATE_FAILURE, errorMessage }
}

export function submitUpdateSection(formData) {
  // TODO: eliminate dependency on stringify since denormalize should not be returning circular references.
  // This is probably caused when sections and courses are loaded together
  return dispatch => {
    dispatch(beginSectionUpdate())
    return fetch(`/sections/${formData.section.id}`, {
      credentials: 'include',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: stringify(formData, null, 2)
    })
    .then(response => handleApiResponse(response))
    .then(json => {
      if(json.unauthorized){ dispatch(sectionUpdateFailure(json.unauthorized)) }
      else if(json.errors){ dispatch(sectionUpdateFailure(json.errors.join("\n"))) }
      else {
        let passwords = {}
        _.each(json.student_profiles_attributes, attrs => passwords[attrs.uuid] = attrs.password)
        dispatch(sectionUpdateSuccess(passwords))
        dispatch(fetchStudentGroupings())
      }
    })
    .catch(error => dispatch(sectionUpdateFailure(error.message)))
  }
}

export function sectionSubmitSuccessHandled() {
  return { type: SECTION_SUBMIT_SUCCESS_HANDLED }
}

export function setFieldAutoGeneration(isAutoGenerating) {
  return { type: SET_FIELD_AUTO_GENERATION, isAutoGenerating }
}

export function clearPasswords() {
  return { type: CLEAR_PASSWORDS }
}

export function fetchStudentGroupings() {
  return dispatch => {
    const callbacks = {
      onSuccess:  ()=>{},
      onError:    error=>{}
    }
    apiReadWithAuth(dispatch, '/instructors?include=profile,course,course.sections,course.sections.students.profile', callbacks)
  }
}
